import LOGO from "../images/raptors.png";

export const Team__Raptors = {
  name: "Raptors",
  logoImage: LOGO,
  teamImage: null,
  teamLogoColor: "#4c0553ff",
  teamJerseyColor: "#E6DE0B",

  // Stats
  gamesWon: 1,
  gamesLost: 3,
  gamesTied: 0,
  gamesTiedWon: 0,

  ownGoalsInFavor: 0,
  goalsScoredAgainst: 27 + 15 + 23 + 25,
  defaultGoals: 0,

  isChampion: false,
  isEliminated: false,

  players: [
    {
      goalsScored: 16 + 34 + 22 + 21,
    },
  ],
};
